import {eventSlots, parseSetupKey, resolveSetupEvent, matchTitle} from "./eventSetup";
import {lineupProjection, lineupSignature} from "./matchLineup";

// Studio reads saved results, overlaid with the live shared setup. Empty map
// slots never become stats rows. Actual played dates and results stay intact.
export function setupStatsProjection(stats, events) {
  const event = resolveSetupEvent(events, stats.calendarEventId || "");
  if (!event) return stats;
  const identity = parseSetupKey(stats.calendarEventId);
  const slot = eventSlots(event).find(item => item.id === (identity?.slotId || "map-1") && item.statsId === stats.id);
  if (!slot) return stats;
  const gameType = {Scrim:"Scrims", "Game Day":"Official Match", Premier:"Premier", Ranked:"Ranked"}[event.tag];
  return {...stats, ...lineupProjection(slot), title: matchTitle(event, slot), map: slot.mapName || "", opponent: event.opponentName || "",
    compositionPreset:slot.compositionPreset?.lineupSignature === lineupSignature(slot.lineup) ? slot.compositionPreset : null,eventTag:event.tag || "",eventSubtag:event.scrimType || "",
    competition: event.competition || "", gameType: gameType || event.tag || stats.gameType, calendarEventStartUTC: event.startUTC};
}
